<template>
    <div class="commonFormStyles driverTransSheetInfo-box">
        <HeaderNav
            header-title="交付信息"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <section class="form-con">
            <van-collapse v-model="activeNames">
                <van-collapse-item name="1" class="">
                    <div slot="title">
                        <span class="iconfont icondanjubianhao"></span>
                        <span class="tit-text">基本信息</span>
                    </div>
                    <div class="form-group">
                        <van-cell-group>
                            <van-cell
                                title="工程名称"
                                :value="formData.project_name"
                                :icon="require('@/assets/images/icons/icon_2.png')"
                            ></van-cell>
                            <van-cell
                                title="施工部位"
                                :value="formData.place_name"
                                :icon="require('@/assets/images/icons/icon_gy_2.png')"
                            ></van-cell>
                            <van-cell
                                title="运输单号"
                                :value="formData.pcb_number"
                                :icon="require('@/assets/images/icons/icon_gy_1.png')"
                            ></van-cell>
                            <van-cell
                                title="到达时间"
                                :value="formData.arrive_time"
                                :icon="require('@/assets/images/icons/icon_gy_7.png')"
                            ></van-cell>
                            <van-cell
                                title="强度等级"
                                :value="formData.strength_grade_name"
                                :icon="require('@/assets/images/icons/icon_gy_3.png')"
                            ></van-cell>
                            <van-cell
                                title="外加剂"
                                :value="formData.special_require_name"
                                :icon="require('@/assets/images/icons/icon_6.png')"
                            ></van-cell>
                            <van-cell
                                title="坍落度"
                                :value="`${formData.slump}±${formData.slump_name}`"
                                :icon="require('@/assets/images/icons/icon_16.png')"
                            ></van-cell>
                        </van-cell-group>
                    </div>
                </van-collapse-item>
            </van-collapse>
            <van-form ref="transSheet" class="form-group">
                <van-cell
                    title="开始卸料时间"
                    :value="formData.unload_time"
                    :icon="require('@/assets/images/icons/icon_gy_7.png')"
                ></van-cell>
                <van-cell
                    title="结束卸料时间"
                    :value="formData.unload_over_time"
                    :icon="require('@/assets/images/icons/icon_gy_7.png')"
                ></van-cell>
                <van-cell
                    title="本车方量"
                    :value="formData.volume"
                    :icon="require('@/assets/images/icons/icon_30.png')"
                ></van-cell>
                <van-cell
                    title="签收方量"
                    :value="formData.unload_volume"
                    :icon="require('@/assets/images/icons/icon_30.png')"
                ></van-cell>
                <van-cell
                    title="是否剩退灰"
                    :value="formData.is_surplus"
                    :icon="require('@/assets/images/icons/my_9.png')"
                ></van-cell>
            </van-form>
            <div class="upload-con group-item">
                <div class="tit">
                    <span class="iconfont icondingdan"></span>
                    <span>上传资料</span>
                </div>
                <div class="file-list">
                    <ul>
                        <li v-for="(item, index) in imgUrls" :key="item" @click="imageView(index)">
                            <img :src="item">
                        </li>
                    </ul>
                </div>
            </div>
            <div class="group-item" style="border-bottom:none;">
                <div class="tit">
                    <span class="iconfont iconpingjia"></span>
                    <span>评价信息</span>
                </div>
                <div class="evaluate">
                    <div class="item" v-for="(item, index) in saveData.evaluateDetails" :key="index">
                        <label>{{ item.option_name }}</label>
                        <van-rate v-model="item.score" readonly></van-rate>
                        <span class="tip" v-if="item.score===5">非常好</span>
                        <span class="tip" v-else-if="item.score===4">好</span>
                        <span class="tip" v-else-if="item.score===3">一般</span>
                        <span class="tip" v-else-if="item.score===2||item.score===1">差</span>
                        <span class="tip" v-else></span>
                    </div>
                </div>
            </div>
            <div class="option-con">
                <span class="iconfont iconbeizhu"></span>
                <!-- <div></div> -->
                <textarea v-model="saveData.driver_remark" readonly></textarea>
            </div>
        </section>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import { Toast, ImagePreview } from 'vant';
export default {
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            activeNames: [],
            formData: {}, // 回显运输单信息
            value: 0,
            saveData: {
                pcb_number: '',
                task_number: '',
                unload_volume: null,
                evaluateDetails: [
                    {
                        eva_id: '',
                        option_id: '1',
                        option_name: '要料人配合程度',
                        score: 0,
                    },
                    {
                        eva_id: '',
                        option_id: '2',
                        option_name: '工地压车程度',
                        score: 0,
                    },
                    {
                        eva_id: '',
                        option_id: '3',
                        option_name: '施工方用灰规范程度',
                        score: 0,
                    },
                    {
                        eva_id: '',
                        option_id: '4',
                        option_name: '施工方退料情况',
                        score: 0,
                    },
                ], // 评分
                driver_files: '', // 附件
                driver_remark: '',
            },
            fileList: [],
            handleType: '',
            imgUrls: [],
            isIOS: false, // 苹果/安卓手机
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 获取司机运输单
        getDriverPcb() {
            this.$axios
                .get('/interfaceApi/production/productpcb/get_driver_pcb?pcb_number=' + this.pcb_number)
                .then(res => {
                    if (res) {
                        this.formData = res;
                        if (this.formData.is_surplus === 1) {
                            this.formData.is_surplus = '是';
                        } else {
                            this.formData.is_surplus = '否';
                        }
                    }
                })
                .catch(error => {
                    this.$toast(error.Errorcode.Message);
                });
        },
        // 图片预览
        imageView(index) {
            ImagePreview({ images: this.imgUrls, startPosition: index });
        },
        // 展示电子运单
        toElectronicTicket(data) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'electronicTicket', params: { pcb_number: data.pcb_number } });
        },
        // 拉取司机评价信息
        getDriverEvaluate() {
            this.$axios
                .get('/interfaceApi/production/productpcb/get_driver_evaluate?pcb_number=' + this.pcb_number)
                .then(res => {
                    this.saveData = res;
                    if (this.saveData.driver_files) {
                        let fileStr = this.saveData.driver_files;
                        const comma = fileStr.charAt(fileStr.length - 1);
                        if (comma === ',') {
                            fileStr = fileStr.substring(0, fileStr.length - 1);
                        }
                        const fileArr = fileStr.split(',');
                        fileArr.map(item => {
                            this.getFileDetailFun(item);
                        });
                    }

                })
                .catch(error => {
                    this.$toast(error.Errorcode.Message);
                });
        },
        // 获取文件下载预览地址
        getFileDetailFun(item) {
            const url = `${this.GLOBAL.FILE_BASE_URL}file-manage/${item}/download`;
            this.imgUrls.push(url);
        },

    },
    created() {

    },
    mounted() {
        this.pcb_number = this.$route.params.pcb_number;
        this.getDriverPcb();
        this.getDriverEvaluate();
    },
};
</script>
<style lang="stylus">
.driverTransSheetInfo-box
    height calc(100% - 44rpx)
    .hader-nav
        position initial
    .form-con
        height 100%
        overflow-y auto
        overflow-x hidden
        .icondanjubianhao
            font-size 18rpx
            margin-right 10rpx
            float left
            color #666
        .tit-text
            float left
        .view-electronic
            float right
            color #E60000
        .van-form
            .van-cell
                padding 0
        .van-collapse-item__content
            padding 0 0 0 0
        .van-cell__title
            font-size 14rpx
        .van-collapse-item__title--expanded
            .van-cell__title
                color #3495FB
                .icondanjubianhao
                    color #3495FB
        .form-group
            .van-cell
                padding 10rpx 10rpx 10px 16rpx;
                font-size 14rpx
            .van-field__control
                text-align right
            .cell-icon
                width 16rpx
                height 16rpx
                display inline-block
                background-repeat no-repeat
                background-size 100% 100%
                margin-top 3rpx
            .cell1
                background-image url(./../../../assets/images/icons/icon_2.png)
            .cell2
                background-image url(./../../../assets/images/icons/icon_gy_2.png)
            .cell3
                background-image url(./../../../assets/images/icons/icon_gy_1.png)
            .cell4
                background-image url(./../../../assets/images/icons/icon_gy_7.png)
            .cell5
                background-image url(./../../../assets/images/icons/icon_gy_3.png)
            .cell6
                background-image url(./../../../assets/images/icons/icon_6.png)
            .cell7
                background-image url(./../../../assets/images/icons/icon_16.png)
            .cell8
                background-image url(./../../../assets/images/icons/icon_30.png)
            .van-field__left-icon
                margin-right 10rpx
            .van-cell:not(:last-child)::after
                left 0
            .star
                color #E60000
            .van-field__label
                width 160rpx
            .van-field__error-message
                text-align right
    .option-con
        width 100%
        padding 14rpx
        padding-top 0
        position relative
        textarea
            height 132rpx
            width 100%
            border 1px solid #D7D7D7
            border-radius 5rpx
            padding 10rpx
        .iconbeizhu
            position absolute
            left 20rpx
            top 20rpx
            display none
    .group-item
        padding 10rpx 16rpx
        border-bottom 1px solid #F0F0F0
        .tit
            color #3495FB
            margin-bottom 15rpx
            .iconfont
                font-size 16rpx
                margin-right 10rpx
        .situation-types
            span
                height 30rpx
                background #F1F1F1
                border-radius 8rpx
                line-height 30rpx
                padding 0 12rpx
                display inline-block
                font-size 14rpx
                margin 0 6rpx 10rpx 0
        .evaluate
            .item
                margin-bottom 15rpx
                font-size 14rpx
                overflow hidden
                label
                    line-height 0rpx
                    width 145rpx
                    float left
                .van-rate
                    float left
                    margin-right 20rpx
                .tip
                    float left
        &.upload-con
            overflow hidden
            .file-list
                li
                    overflow hidden
                    border-radius 4rpx
                    float left
                    margin 0 5rpx 5rpx 0
                    width 80rpx
                    height 80rpx
                    img
                        width 80rpx
                        height 80rpx
                .rz-picter
                    ul
                        float left
                    .upload-icon
                        float left
                        width 80rpx
                        height 80rpx
                        position relative
                        .file-input
                            position absolute
                            left 0
                            top 0
                            width 100%
                            height 100%
                            opacity 0
                        .img-bg
                            background #f7f8fa
                            height 100%
                            border-radius 4rpx
                            text-align center
                            line-height 80rpx
                            .iconfont
                                color #dcdee0


</style>
<style>
.driverTransSheetInfo-box .van-collapse-item__title .van-cell__right-icon::before{
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
}
.driverTransSheetInfo-box .van-collapse-item__title--expanded .van-cell__right-icon::before{
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
}
.driverTransSheetInfo-box input::-webkit-input-placeholder{
    color: #E60000;
}
</style>